import { Padrao } from '../generic/padrao';

export class FiscalNcm extends Padrao{

    override idTab = 162;

    descricao: string;
    und: string;
}